import Render from 'common/Render';
import makeRoutes from './routes';
import _debug from 'debug';

const debug = _debug('app::memo');

export function edit(ctx) {
  const id = ctx.params.id;
  if (id) {
    debug(`Rendering technical memo ${id}`);

    Render.render(store => makeRoutes(store, id));
  }
}



// WEBPACK FOOTER //
// ./src/modules/memo/index.js